import React from 'react';
import I18n from 'i18n-js';
import GoogleDriveIcon from '../../../../../public/assets/images/google-drive.svg';
import SaveToGoogleDrive from '@/components/shared/SaveToGoogleDrive';
import { AssessmentInfo } from '../types';

interface SaveToGoogleDriveOptionProps {
  answerKey?: boolean;
  assessment: AssessmentInfo;
  url: string;
}

const SaveToGoogleDriveOption = ({ answerKey, assessment, url }: SaveToGoogleDriveOptionProps) => {
  const label = answerKey
    ? I18n.t('libraries.assessments.save_answer_key_to_drive')
    : I18n.t('libraries.assessments.save_assessment_to_drive');
  const iconStyle = 'width:18px;height:18px;display:inline-block;vertical-align:-4px;margin-right:0.5rem;';
  const linkText = `<img alt="" src="${GoogleDriveIcon}" style="${iconStyle}" /> ${label}`;

  return (
    <SaveToGoogleDrive
      assessmentLibrary
      button={false}
      fileName={assessment.name}
      fileUrl={url}
      linkClasses="tw-text-sm tw-text-very-dark-grey tw-leading-7"
      linkText={linkText}
    />
  );
};

export default SaveToGoogleDriveOption;
